'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ListPresentational = require('./ListPresentational');

var _ListPresentational2 = _interopRequireDefault(_ListPresentational);

var _ListContainer = require('./ListContainer');

var _ListContainer2 = _interopRequireDefault(_ListContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = function List(props) {
    var isPresentational = props.isPresentational;

    var DisplayList = isPresentational ? _ListPresentational2.default : _ListContainer2.default;

    return _react2.default.createElement(DisplayList, props);
};

List.propTypes = {
    isPresentational: _propTypes2.default.bool
};

exports.default = List;


//////////////////
// WEBPACK FOOTER
// ./src/client/list/List.js
// module id = 744
// module chunks = 0